import { render, staticRenderFns } from "./UserProgressionDetail.vue?vue&type=template&id=7a037b36&scoped=true&"
import script from "./UserProgressionDetail.vue?vue&type=script&lang=js&"
export * from "./UserProgressionDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserProgressionDetail.vue?vue&type=style&index=0&id=7a037b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a037b36",
  null
  
)

export default component.exports